



















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UploadFile } from "@/request/common";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Watch("data", { immediate: true })
  private dataChange() {
    this.detail = this.data;
  }
  private detail: any = {};
  private preview(url: any) {
    window.open(url);
  }
  private delImg(i: any) {
    this.detail.pic_list.splice(i, 1);
  }
  private upload(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading)
      .then((res: any) => {
        loading.close();
        this.detail.pic_list.push(res.full_file_url);
        this.update();
      })
      .catch(() => {
        loading.close();
      });
  }
  private update() {
    this.$emit("update", this.detail);
  }
  private mounted() {
    this.detail = {
      pic_list: [],
    };
  }
}
